import { render, staticRenderFns } from "./ErrorForbidden.vue?vue&type=template&id=91a76c90"
import script from "./ErrorForbidden.js?vue&type=script&lang=js&external"
export * from "./ErrorForbidden.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports